import { createContext } from 'react';

export const IsMobileContext = createContext(false);
export const DataSourceContext = createContext(null);
// The search form's white panel (a ref), for pickers whose panel spans the whole form (the airports).
export const FormPanelContext = createContext(null);